module.exports = __webpack_public_path__ + "img/suit_stand_bg.0217c8ff.png";